import { styled } from "@linaria/react"


import { AvatarStub } from "@/components/Avatar/Avatar.tsx"
import { Spring, Vertical } from "@/components/Flex.ts"
import { Loading } from "@/components/Loading.tsx"
import { Logo } from "@/routes/auth/Logo.tsx"
import { MainMenu } from "@/routes/auth/MainMenu.tsx"
import { UserMenu } from "@/routes/auth/UserMenu.tsx"
import { mobileBreakpoint } from "@/styles/mixins.ts"

import type { RouterState } from "@tanstack/react-router"
import type { ReactNode } from "react"

export const NavigationBarWidth = 88
export const NavigationBarWidthMobile = 72

export const NavigationBar = (props: {
  state: RouterState
  orgPage?: boolean
  withMainMenu?: boolean
  withUserMenu?: boolean
  mainMenuBuilder?: ReactNode
}) => {
  return (
    <Container>
      <Logo {...props} />
      {(props.withMainMenu === undefined || props.withMainMenu) && <MainMenu>{props.mainMenuBuilder}</MainMenu>}
      <Spring />
      {(props.withUserMenu === undefined || props.withUserMenu) && <Loading renderLoading={<AvatarStub size={40} />}><UserMenu /></Loading>}
    </Container>
  )
}

const Container = styled(Vertical)`
  pointer-events: none;

  * {
    pointer-events: auto;
  }

  position: fixed;
  left: 0;
  top: 0;

  align-items: center;
  gap: 24px;

  height: 100vh;
  padding: 20px 24px;

  @media ${mobileBreakpoint} {
    padding: 20px;
  }

  z-index: 1;
`